<template>
  <div>
    <v-card
      v-if="!isLoading"
      class="main--text"
      width=800>
      <v-container
        fluid
        >
        <v-row
          no-gutters
          align=center
          justify=start>
          <v-col
            cols=auto
            >
            <span class="font-weight-bold" style="font-size:1.3rem">ご登録情報 </span>
            <v-icon
              small
              @click="$emit('edit-button-click')">fa-edit</v-icon>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          >
          <v-col>
            <v-list two-line>
              <template
                v-for="item in items">
                <v-list-item
                  v-if="item.title"
                  :key="item.title" >
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{item.title}}
                    </v-list-item-subtitle>
                    <v-list-item-title style="font-size:1.1rem">
                      {{item.value}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="item.divider"
                  :key="item.index"></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>
        <v-row
          dense>
          <v-col>
            <v-btn
              rounded
              outlined
              color="primary"
              @click="$emit('card-info-button-click')">お支払い情報
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <Loading 
      v-else/>
  </div>
</template>

<script>
import Loading from '@/components/organisms/Loading'
export default {
  props: {
    parent: Object
  },
  components: {
    Loading
  },
  data() {
    return {
      items: [],
      creditcard: null,
      isLoading: true
    }
  },
  created: function() {
    this.items = [
      {
        title: "氏名",
        value: this.parent.fullName(),
        icon: "fa-venus-mars",
        divider: true
      },
      {
        title: "性別",
        value: this.parent.genderInJapanese(),
        icon: "fa-venus-mars",
        divider: true
      },
      {
        title: "生年月日",
        value: this.parent.birthdayToString(),
        icon: "fa-birthday-cake",
        divider: true
      },
      {
        title: "メールアドレス",
        value: this.parent.email,
        icon: "fa-envelope",
        divider: true
      },
      {
        title: "電話番号",
        value: this.parent.phone,
        icon: "fa-phone",
        divider: true
      },
      {
        title: "住所",
        value: this.parent.fullAddress(),
        icon: "fa-map-marker-alt",
        divider: true
      },
      {
        title: "最寄り駅",
        value: this.parent.nearestStation,
        icon: "fa-train",
        divider: true
      }
    ]
    this.isLoading = false
  }
}
</script>
